import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import Founder from "@/pages/Founder";
import Nutrition from "@/pages/Nutrition";
import KnowledgeLibrary from "@/pages/KnowledgeLibrary";
import ArticlePage from "@/pages/ArticlePage";
import FutureSimulator from "@/pages/FutureSimulator";
import TwinShare from "@/pages/TwinShare";
import MedicalID from "@/pages/MedicalID";
import HospitalFinder from "@/pages/HospitalFinder";
import Wearables from "@/pages/Wearables";
import Sleep from "@/pages/Sleep";
import Family from "@/pages/Family";
import Community from "@/pages/Community";
import NeuroRehab from "@/pages/NeuroRehab";
import NeuroSpeak from "@/pages/NeuroSpeak";
import NeuroMotor from "@/pages/NeuroMotor";
import Impact from "@/pages/Impact";
import Profile from "@/pages/Profile";
import WellnessTools from "@/pages/WellnessTools";
import ProgrammaticTool from "@/pages/ProgrammaticTool";
import Waitlist from "@/pages/Waitlist";
import HealthHistory from "@/pages/HealthHistory";
import DiabetesCentre from "@/pages/DiabetesCentre";
import HealthAI from "@/pages/HealthAI";
import { Toaster } from "@/components/ui/sonner";
import { ChatbotProvider } from "@/context/ChatbotContext";
import ChatbotDialog from "@/components/silentscan/ChatbotDialog";
import { MentalProvider } from "@/context/MentalContext";
import MentalWellnessDialog from "@/components/silentscan/MentalWellnessDialog";
import EmergencyButton from "@/components/silentscan/EmergencyButton";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/silentscan/AuthCallback";
import AuthDialog from "@/components/silentscan/AuthDialog";
import MobileBottomNav from "@/components/silentscan/MobileBottomNav";

// Completely free — no payments. Free accounts exist only to keep each
// person's health history private, persistent and available across devices.
function AppRouter() {
  const location = useLocation();
  // Detect the Emergent OAuth session_id in the URL fragment synchronously
  // during render (useLocation().hash — reactive, unlike window.location.hash).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/founder" element={<Founder />} />
      <Route path="/nutrition" element={<Nutrition />} />
      <Route path="/health-ai" element={<HealthAI />} />
      <Route path="/assistant" element={<Navigate to="/health-ai" replace />} />
      <Route path="/library" element={<KnowledgeLibrary />} />
      <Route path="/library/:slug" element={<ArticlePage />} />
      <Route path="/simulator" element={<FutureSimulator />} />
      <Route path="/medical-id" element={<MedicalID />} />
      <Route path="/hospitals" element={<HospitalFinder />} />
      <Route path="/twin/:shareId" element={<TwinShare />} />
      <Route path="/wearables" element={<Wearables />} />
      <Route path="/sleep" element={<Sleep />} />
      <Route path="/family" element={<Family />} />
      <Route path="/community" element={<Community />} />
      <Route path="/neurorehab" element={<NeuroRehab />} />
      <Route path="/neurospeak" element={<NeuroSpeak />} />
      <Route path="/neuromotor" element={<NeuroMotor />} />
      <Route path="/impact" element={<Impact />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/tools" element={<WellnessTools />} />
      <Route path="/tools/:slug" element={<ProgrammaticTool />} />
      <Route path="/waitlist" element={<Waitlist />} />
      <Route path="/history" element={<HealthHistory />} />
      <Route path="/diabetes" element={<DiabetesCentre />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

function AppShell() {
  const { user } = useAuth();
  return (
    <ChatbotProvider>
      <MentalProvider>
        <div
          className={`App bg-[#05050A] text-white min-h-screen${
            user
              ? " pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-0"
              : ""
          }`}
        >
          <AppRouter />
          <ChatbotDialog />
          <MentalWellnessDialog />
          <AuthDialog />
          <EmergencyButton />
          <MobileBottomNav />
          <Toaster theme="dark" position="bottom-right" />
        </div>
      </MentalProvider>
    </ChatbotProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
